import type { ReactElement } from 'react';
import { Navigate, Route, useSearchParams } from 'react-router';
import { ModuleGate } from '../../components/ModuleGate';
import type { BackofficeModule } from '../registry';
import { FleetDetailPage } from './FleetDetailPage';
import { FleetPage } from './FleetPage';

const gate = (permission: string, element: ReactElement) => <ModuleGate module="fleet" permission={permission}>{element}</ModuleGate>;

/**
 * Einstiegspunkt des Moduls Flotte im Backoffice (KON-167, Schlüssel `fleet`, siehe docs/flotte.md): Fahrzeuge mit Fristen, Wartung, Kosten und Fahrtenbuch unter /flotte. Das Fahrtenbuch gehört zum Fahrzeug
 * (KON-252): Die frühere Adresse /fahrtenbuch leitet in die Flotte um.
 */
function LegacyLogbook() {
  const [params] = useSearchParams();
  const vehicleId = params.get('vehicleId');
  return <Navigate to={vehicleId ? `/flotte/${vehicleId}` : '/flotte'} replace />;
}

export const fleetModule: BackofficeModule = {
  key: 'fleet',
  path: '/flotte',
  nav: [{ label: 'Flotte', path: '/flotte' }],
  routes: (
    <>
      <Route path="flotte" element={gate('fleet.read', <FleetPage />)} />
      <Route path="flotte/:id" element={gate('fleet.read', <FleetDetailPage />)} />
      <Route path="fahrtenbuch" element={<LegacyLogbook />} />
    </>
  ),
};
